import { render, staticRenderFns } from "./NumberOfDiplomas.vue?vue&type=template&id=331e287d&"
import script from "./NumberOfDiplomas.vue?vue&type=script&lang=js&"
export * from "./NumberOfDiplomas.vue?vue&type=script&lang=js&"
import style0 from "./NumberOfDiplomas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports